"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { ApiWaveMetadataType } from "@/generated/models/ApiWaveMetadataType";
type CreateDropMetadataType = {
  readonly id: string;
  key: string;
  readonly type: ApiWaveMetadataType.String;
  value: string | null;
  readonly required: boolean;
} | {
  readonly id: string;
  key: string;
  readonly type: ApiWaveMetadataType.Number;
  value: number | null;
  readonly required: boolean;
} | {
  readonly id: string;
  key: string;
  readonly type: null;
  value: string | null;
  readonly required: boolean;
};
interface UseDropMetadataProps {
  readonly isDropMode: boolean;
  readonly requiredMetadata: {
    readonly name: string;
    readonly type: ApiWaveMetadataType;
  }[];
}
const isValueSet = (md: CreateDropMetadataType): boolean => {
  if (md.value === null) return false;
  if (typeof md.value === "string") return md.value !== "";
  if (typeof md.value === "number") return true;
  return false;
};
export const generateMetadataId = () => typeof crypto !== "undefined" && typeof crypto.randomUUID === "function" ? crypto.randomUUID() : Math.random().toString(36).slice(2);
const createInitialDropMetadata = (requiredMetadata: UseDropMetadataProps["requiredMetadata"]) => {
  return requiredMetadata.map(md => ({
    id: generateMetadataId(),
    key: md.name,
    type: md.type,
    value: null,
    required: true
  }));
};
const createEmptyMetadata = () => {
  return [];
};
const addMissingRequiredMetadata = (currentMetadata: CreateDropMetadataType[], initialMetadata: CreateDropMetadataType[]) => {
  const missingMetadata = initialMetadata.filter(initMd => !currentMetadata.some(md => md.key === initMd.key));
  return [...currentMetadata, ...missingMetadata];
};
const removeUnsetRequiredMetadata = (metadata: CreateDropMetadataType[]) => {
  return metadata.filter(md => !md.required || isValueSet(md));
};
export const useDropMetadata = t0 => {
  const $ = _c(10);
  const {
    isDropMode,
    requiredMetadata
  } = t0;
  let t1;
  if ($[0] !== isDropMode || $[1] !== requiredMetadata) {
    t1 = isDropMode ? createInitialDropMetadata(requiredMetadata) : createEmptyMetadata();
    $[0] = isDropMode;
    $[1] = requiredMetadata;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const initialMetadata = t1;
  const [metadata, setMetadata] = useState(initialMetadata);
  let t2;
  let t3;
  if ($[3] !== initialMetadata || $[4] !== isDropMode) {
    t2 = () => {
      setMetadata(prev => {
        const updatedMetadata = isDropMode ? addMissingRequiredMetadata(prev, initialMetadata) : removeUnsetRequiredMetadata(prev);
        return JSON.stringify(updatedMetadata) !== JSON.stringify(prev) ? updatedMetadata : prev;
      });
    };
    t3 = [isDropMode, initialMetadata];
    $[3] = initialMetadata;
    $[4] = isDropMode;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== initialMetadata || $[8] !== metadata) {
    t4 = {
      metadata,
      setMetadata,
      isValueSet,
      initialMetadata
    };
    $[7] = initialMetadata;
    $[8] = metadata;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};